export class Notification {
    constructor(
        public id: any,
        public created_at: any,
        public sent_to: any,
        public title: string,
        public description: string,
        public is_read: boolean,
        public notification_type: string,
        public bound_id: string,
    ) { }
}
